import React, {lazy, Suspense, useEffect} from "react";
import "./App.scss";
import { BrowserRouter, Route, Switch, useLocation } from "react-router-dom";
import ProtectedRoute from './auth/ProtectedRoute';
import "./App.css";
import PageLoader from './components/PageLoader';
import utilsCommon from "./utils/common";
import LinkName from "./constants/linkName";
import smoothscroll from 'smoothscroll-polyfill';


/**
 *
 * @returns
 */
export default function App() {

    const location = useLocation();
    smoothscroll.polyfill();
    // check entry point
    utilsCommon.checkEntryPoint(location.pathname);

    /**
     * check browser
     */
    // if (utilsCommon.isCompatibleBrowsers() === false) {
    //     return <ScreensError msgCode="ERR_BROWSER" />;
    // }

    const handleResize = () => {


            if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i)) {
                var viewportmeta = document.querySelector('meta[name="viewport"]');
                if (viewportmeta) {
                    viewportmeta.content = 'width=device-width, minimum-scale=1.0, maximum-scale=1.0, initial-scale=1.0';
                    document.addEventListener('gesturestart', function () {
                        viewportmeta.content = 'width=device-width, minimum-scale=0.25, maximum-scale=1.6';
                    }, false);
                }
            }


        }

    useEffect(()=>{

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        }
    },[]);

    return (
        <BrowserRouter basename="/meal">
            <Suspense fallback={<PageLoader />}>
                <Switch>
                    <Route exact path={LinkName.ERROR_AVAILABLE} component={lazy(() => import('./screens/Error/ScreensErrorDevice.jsx'))} />
                    <Route exact path={LinkName.ERROR_VALID_TIME} component={lazy(() => import('./screens/Error/ScreensErrorOutsiteTime.jsx'))} />
                    <Route exact path={LinkName.ERROR_COMMON} component={lazy(() => import('./screens/Error/Error.jsx'))} />
                    <Route exact path={LinkName.ERROR_LICENSE} component={lazy(() => import('./screens/Error/License.jsx'))} />
                    <Route exact path={LinkName.LOGIN} component={lazy(() => import('./screens/Login/Login.jsx'))} />
                    <ProtectedRoute exact path={LinkName.TITLE} component={lazy(() => import('./screens/Title/Title.jsx'))} />
                    <ProtectedRoute exact path={LinkName.REGISTER_NAME} component={lazy(() => import('./screens/NameRegistration/NameRegistration.jsx'))} />
                    <ProtectedRoute exact path={LinkName.SELECT_SCHOOL_YEAR} component={lazy(() => import('./screens/SelectionSchoolYear/SelectionSchoolYear.jsx'))} />
                    <ProtectedRoute exact path={LinkName.CONTINUE} component={lazy(() => import('./screens/Continue/Continue.jsx'))} />
                    <ProtectedRoute exact path={LinkName.MENU_TABLE} component={lazy(() => import('./screens/MenuTable/MenuTable.jsx'))} />
                    <ProtectedRoute exact path={LinkName.CHOICE_SUBJECT} component={lazy(() => import('./screens/ChoiceTask/List.jsx'))} />
                    <ProtectedRoute exact path={LinkName.DELETE_DATA} component={lazy(() => import('./screens/DeleteDataSave/DeleteDataSave.jsx'))} />
                    <ProtectedRoute exact path={LinkName.MAIN} component={lazy(() => import('./screens/ChooseDish/ChooseDish.jsx'))} />
                    <ProtectedRoute exact path={LinkName.CONDITION_SETTING} component={lazy(() => import('./screens/ConditionSetting/ConditionSetting.jsx'))} />
                    <ProtectedRoute exact path={LinkName.NUTRIENTS_GRAPH} component={lazy(() => import('./screens/Graph/Graph.jsx'))} />
                    <ProtectedRoute exact path={LinkName.NUTRIENTS_SHEET} component={lazy(() => import('./screens/ClassificationSheet/ClassificationSheet.jsx'))} />
                </Switch>
            </Suspense>
        </BrowserRouter>
    );
}
